import React, { Component } from 'react'
import './css.css';
import Web3 from 'web3';
import utils from './../../library'
import TreeStaker from './../TreeStaker/TreeStaker'

class Book extends Component {
constructor(props){
    super()
    this.openShop = this.openShop.bind(this);
    this.state={page:0,show:"stake"}
}
    componentDidMount(){
       //this.loadShops(0,this.state.show)
        utils.loadOwnerColors()
        this.loadStake(0)
    }

    async openShop(shop){
        window.history.pushState('show_shop', 'Shop Display', '/smartshop/?shop='+shop);
        this.props.jumptoshop()
    }

    async prev(){
        if(this.state.page>0){
        this.setState({page:this.state.page-1})
        this.loadShops(this.state.page-1,this.state.show)
        }
    }

    async next(){
        
        let pag=this.state.page
        let show=this.state.show
        
        
       
        await window.ethereum.enable().then(async function (accounts) {
    
            const { REACT_APP_BOOKABI } = await process.env;
            const { REACT_APP_BOOK } = await  process.env;
            const book = new web3.eth.Contract(JSON.parse(REACT_APP_BOOKABI), REACT_APP_BOOK) 
            let res=await book.methods.door(0).call()
            let count=res[1]
        if(pag<parseInt(count/10)){
            pag++
        }
        })
        this.setState({page:pag})
        this.loadShops(pag,show)
        
        //this.render()
    }

    showNewest(){
         this.setState({show:"new"})
         this.loadShops(this.state.page,"new")
        }

    showStaked(){
            this.setState({show:"stake"})
    this.loadStake(0)
    }

    showEdit(){
        this.setState({show:"edit"})

    }

    showOldest(){
        this.setState({show:"old"})
        this.loadShops(this.state.page,"old")
    }

    async loadStake(pag) {
        document.getElementById("book_board").innerHTML=""
        window.ethereum.enable().then(async function (accounts) {
            let account=accounts[0];
            const beans = new web3.eth.Contract(TREESTAKER_ABI, TREESTAKER) 
            let leafs = await beans.methods.leafs().call()
            let top=(pag+1)*10
            if(top>leafs)top=leafs

            let gene=await beans.methods.list(0).call()
            let gene_next=gene[1]
            for(let i=0+(pag*10);i<top;i++){
            gene=await beans.methods.list(gene_next).call()
            if(gene[1]!=10000000000000000){
                const leaf = document.createElement('div');
                leaf.className="TreeStaker_leaf"
                leaf.innerHTML=gene_next+" "+gene[4]+" "+gene[2]+" "+gene[0]+" "+gene[1]
                //document.getElementById("TreeStakers_staking_list").appendChild(leaf)
                gene_next=gene[1]

                const { REACT_APP_TICKETABI } = await  process.env;
                const door = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), gene[4]) 
                let code= await door.methods.code().call()
                let box= await door.methods.box().call()
                const { REACT_APP_HAPPYBOXABI } = await  process.env;
                const boxC = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), box) 
                let master= await boxC.methods.master().call()
      
                let codeIcon=getCodeIcon(code)

                const { REACT_APP_METAABI } = await process.env;
                const { REACT_APP_META } = await  process.env;
                const metadata = new web3.eth.Contract(JSON.parse(REACT_APP_METAABI), REACT_APP_META) 
                
                let mtdt=await metadata.methods.meta(gene[4]).call()
                let back="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE"
                if(mtdt.length>0){
                    console.log("MTDT",mtdt)
                    fetch(formatURL(mtdt)).then(response => response.json()).then(
                    response => {
                        console.log(JSON.stringify(response))
    
                        back=response[0]["image"]
                        //alert(back)
                        if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                        //document.getElementById("Shop_header_image").style.backgroundImage='url('+response[0]["image"]+')'
                        let container = document.createElement('div');
                        container.className = 'shop_container_minipanel';
                        let book = document.createElement('div');
                        book.className = 'book_icon';
                        book.innerHTML="📘"
                        let tree = document.createElement('div');
                        tree.className = 'TreeStaker_tree_icon';
                        tree.innerHTML="🌈 "+(gene[2]/1000000000000000000)
                        let mainDiv = document.createElement('div');
                        let iDiv = document.createElement('div');
                        let backDiv = document.createElement('div');
                        let iname = document.createElement('div');
                        iDiv.id = 'shop_'+i;
                        iDiv.className = 'shop_link';
                        mainDiv.className = 'shop_maindiv dark darkblue';
                        backDiv.className = 'shop_backdiv';
                        iname.textContent=codeIcon+response[0]["name"];
                        iname.style.margin="100px 20px 0 0"
                        iname.style.fontSize="30px"
                        iname.style.float="right"
                        iDiv.style.backgroundImage='url('+back+')'
                        iDiv.style.backgroundSize='cover'
                        iDiv.appendChild(iname)
                        container.appendChild(mainDiv)
                        //if(master.toLowerCase()==accounts[0].toLowerCase())
                        container.appendChild(tree)
                        mainDiv.appendChild(backDiv)
                        mainDiv.appendChild(iDiv)
                        mainDiv.append(response[0]["description"])
                        mainDiv.addEventListener("click",  () => window.open("/smartshop/?shop="+gene[4]))
                        document.getElementById("book_board").appendChild(container)
       
                    })
                }else{
                let container = document.createElement('div');
                container.className = 'shop_container_minipanel';
                let book = document.createElement('div');
                book.className = 'book_icon';
                book.innerHTML="📘"
                let tree = document.createElement('div');
                tree.className = 'TreeStaker_tree_icon';
                tree.innerHTML="🌈 "+(gene[2]/1000000000000000000)
                let iDiv = document.createElement('div');
                iDiv.id = 'shop_'+i;
                iDiv.className = 'shop_link_empty dark darkblue';
                let iname = document.createElement('div');
                
                iname.style.margin="27px 0 0 0"
                let iIcon = document.createElement('div');
                iIcon.style.margin="00px 0 0 10px"
                iIcon.style.float="left"
                iIcon.innerHTML=codeIcon
                iIcon.style.fontSize="50px"
                iname.innerHTML=gene[4]
                iname.style.fontSize="20px"
                container.appendChild(iDiv)
                
                //if(master.toLowerCase()==accounts[0].toLowerCase())
                container.appendChild(tree)
                iDiv.appendChild(iIcon)
                iDiv.appendChild(iname)
                iDiv.style.backgroundImage='url('+back+')'
                iDiv.style.backgroundSize='cover'
                iDiv.addEventListener("click", () => window.open("/smartshop/?shop="+gene[4]))
                document.getElementById("book_board").appendChild(container)
                }
            }
            if(gene[1]==10000000000000000)i=leafs
            }
if(0==1){
         gene=await beans.methods.list(0).call()
         gene_next=gene[1]
        for(let i=0;i<leafs;i++){
        gene=await beans.methods.list(i).call()

        const leaf = document.createElement('div');
        leaf.className="TreeStaker_leaf"
        leaf.innerHTML=gene_next+" "+gene[4]+" "+gene[2]+" "+gene[0]+" "+gene[1]
        document.getElementById("TreeStakers_staking_list").appendChild(leaf)
        gene_next=gene[1]


    }}
    
          
      
        
        })
    }

    async loadShops(ind,back){
        document.getElementById("book_board").innerHTML=""
        let pag=ind
        let show=back
        let openShop=this.openShop
       //  alert(pag)
        await window.ethereum.enable().then(async function (accounts) {
    
            const { REACT_APP_BOOKABI } = await process.env;
            const { REACT_APP_BOOK } = await  process.env;
            const book = new web3.eth.Contract(JSON.parse(REACT_APP_BOOKABI), REACT_APP_BOOK) 
            let res=await book.methods.door(0).call()
            let count=res[1]
            const { REACT_APP_METAABI } = await process.env;
            const { REACT_APP_META } = await  process.env;
            const metadata = new web3.eth.Contract(JSON.parse(REACT_APP_METAABI), REACT_APP_META) 
            
            document.getElementById("book_sublabel").innerHTML="All Shops List ("+count+")"
            let top=(pag+1)*10
            if(top>count)top=count
           // alert("count "+top)
            for(let i=0+(pag*10);i<top;i++){
              //   alert("i "+i)
                let tempI=i
                if(show=="new")tempI=count-i-1
               //  alert("tempI "+tempI)
                let module_address=await book.methods.door(tempI).call()
                const { REACT_APP_TICKETABI } = await  process.env;
                const door = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), module_address[0]) 
                let code= await door.methods.code().call()
                let box= await door.methods.box().call()
                const { REACT_APP_HAPPYBOXABI } = await  process.env;
                const boxC = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), box) 
                let master= await boxC.methods.master().call()
      
                let codeIcon=getCodeIcon(code)
                let mtdt=await metadata.methods.meta(module_address[0]).call()
                let back="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE"
                if(mtdt.length>0){
                    console.log("MTDT",mtdt)
                    fetch(formatURL(mtdt)).then(response => response.json()).then(
                    response => {
                        console.log(JSON.stringify(response))
    
                        back=response[0]["image"]
                        //alert(back)
                        if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                        //document.getElementById("Shop_header_image").style.backgroundImage='url('+response[0]["image"]+')'
                        let container = document.createElement('div');
                        container.className = 'shop_container_minipanel';
                        let book = document.createElement('div');
                        book.className = 'book_icon';
                        book.innerHTML="📘"
                        let mainDiv = document.createElement('div');
                        let iDiv = document.createElement('div');
                        let backDiv = document.createElement('div');
                        let iname = document.createElement('div');
                        iDiv.id = 'shop_'+tempI;
                        iDiv.className = 'shop_link';
                        mainDiv.className = 'shop_maindiv dark darkblue';
                        backDiv.className = 'shop_backdiv';
                        iname.textContent=codeIcon+response[0]["name"];
                        iname.style.margin="100px 20px 0 0"
                        iname.style.fontSize="30px"
                        iname.style.float="right"
                        iDiv.style.backgroundImage='url('+back+')'
                        iDiv.style.backgroundSize='cover'
                        iDiv.appendChild(iname)
                        container.appendChild(mainDiv)
                        if(master.toLowerCase()==accounts[0].toLowerCase())
                        container.appendChild(book)
                        mainDiv.appendChild(backDiv)
                        mainDiv.appendChild(iDiv)
                        mainDiv.append(response[0]["description"])
                        mainDiv.addEventListener("click",  () => window.open("/smartshop/?shop="+module_address[0]))
                  
                        document.getElementById("book_board").appendChild(container)
       
                    })
                }else{
                let container = document.createElement('div');
                container.className = 'shop_container_minipanel';
                let book = document.createElement('div');
                book.className = 'book_icon';
                book.innerHTML="📘"
                let iDiv = document.createElement('div');
                iDiv.id = 'shop_'+tempI;
                iDiv.className = 'shop_link_empty dark darkblue';
                let iname = document.createElement('div');
                
                iname.style.margin="27px 0 0 0"
                let iIcon = document.createElement('div');
                iIcon.style.margin="00px 0 0 10px"
                iIcon.style.float="left"
                iIcon.innerHTML=codeIcon
                iIcon.style.fontSize="50px"
                iname.innerHTML=module_address[0]
                iname.style.fontSize="20px"
                container.appendChild(iDiv)
                
                if(master.toLowerCase()==accounts[0].toLowerCase())
                container.appendChild(book)
                iDiv.appendChild(iIcon)
                iDiv.appendChild(iname)
                iDiv.style.backgroundImage='url('+back+')'
                iDiv.style.backgroundSize='cover'
                iDiv.addEventListener("click", () => window.open("/smartshop/?shop="+module_address[0]))
            
                    document.getElementById("book_board").appendChild(container)
                
                }
                
            }
            })

    }
   
    

 


    render(){
        console.log(this.props.update) 
        return ( 
        <div>

        <div id="book_flyer">
            <div id="splash_mainlabel">🏰 SmartShop Global Book</div>
            <div id="book_sublabel">All Shops List</div>
            <div id="book_control">
                <div className={(this.state.show=="stake")?"book_navigation_left selected dark darkblue lhover lighthover":"book_navigation_left dhover darkhover"} onClick={() => this.showStaked()}>⭐️</div>
                <div className={(this.state.show=="old")?"book_navigation_left selected dark darkblue lhover lighthover":"book_navigation_left dhover darkhover"} onClick={() => this.showOldest()}>🐓</div>
                <div className={(this.state.show=="new")?"book_navigation_left selected dark darkblue lhover lighthover":"book_navigation_left dhover darkhover"} onClick={() => this.showNewest()}>🐥</div>
                <div className={(this.state.show=="edit")?"book_navigation_left selected dark darkblue lhover lighthover":"book_navigation_left dhover darkhover"} onClick={() => this.showEdit()}>⚙️</div>
                <div className="book_navigation dhover darkhover text white" onClick={() => this.next()}>&gt;</div>
                <div className="book_navigation dhover darkhover text white" onClick={() =>  this.prev()}>&lt;</div>
                <div className="book_pagination text white">{this.state.page}</div>
                <div className="clear"></div>
                </div>
                {(this.state.show=="edit")?
                    <>
                        <TreeStaker page={this.state.page} show={this.state.show}></TreeStaker>
                        <div id="book_board" className="notvisible"></div>
                    </>
                :
                    <>
                        {(this.state.show=="stake")?
                            <div id="book_board"></div>
                        :
                            <div id="book_board"></div>
                        }
                    </>
                }
        </div>
      
        </div>
        );
    }


}

function jumpsocial(add){
    window.open(add)
}


function fire(){}

function getCodeIcon(code){
    let t="📖";
    if(code=="4")t="🎟️"
    if(code=="7")t="🎀"
    if(code=="9")t="💫"
    return t;
}

function formatURL(url){
    return("https://gateway.ipfs.io/ipfs/"+url);
  }


function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}



const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

let TREESTAKER="0x84B00e445e547aD1221d527DD99f99FbE2D39E78"
let TREESTAKER_ABI=[ { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "inputs": [], "name": "leafs", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "list", "outputs": [ { "internalType": "uint256", "name": "prev", "type": "uint256" }, { "internalType": "uint256", "name": "next", "type": "uint256" }, { "internalType": "uint256", "name": "stake", "type": "uint256" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "container", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "mapped", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "owned", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_owner", "type": "address" }, { "internalType": "uint256", "name": "_index", "type": "uint256" } ], "name": "owner", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_container", "type": "address" } ], "name": "readStake", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "address", "name": "_container", "type": "address" }, { "internalType": "uint256", "name": "_stake", "type": "uint256" }, { "internalType": "uint256", "name": "_index", "type": "uint256" } ], "name": "stakeOnTopOf", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "total", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [ { "internalType": "uint256", "name": "_index", "type": "uint256" } ], "name": "unstake", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "stateMutability": "nonpayable", "type": "function" } ]


export default Book